import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
})
